// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowRightSmall = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowRightSmall = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowRightSmall = _exports.ArrowRightSmall = function ArrowRightSmall(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.2439 10.2373C17.2122 10.314 17.1665 10.383 17.109 10.4405L13.7757 13.7739C13.654 13.8955 13.494 13.9572 13.334 13.9572C13.174 13.9572 13.014 13.8964 12.8923 13.7739C12.6481 13.5297 12.6481 13.1338 12.8923 12.8897L15.1589 10.623H3.33398C2.98898 10.623 2.70898 10.343 2.70898 9.99803C2.70898 9.65303 2.98898 9.37303 3.33398 9.37303H15.1581L12.8915 7.10638C12.6473 6.86222 12.6473 6.46635 12.8915 6.22219C13.1356 5.97802 13.5315 5.97802 13.7757 6.22219L17.109 9.55552C17.1665 9.61302 17.2122 9.6821 17.2439 9.75877C17.3072 9.9121 17.3072 10.084 17.2439 10.2373Z",
      fill: "#212B36"
    }));
  };
});
